import { BetaTestingStyle, ReleaseStepType } from '../types';
import * as React from 'react';
import { dayjs } from '@/extendedDayjs';
import { flatMap } from 'lodash';
import Form, { useForm } from 'antd/lib/form/Form';
import Modal from 'antd/lib/modal';
import {
    getBetaTestingStepFields,
    transformStepConfigSettingsToUpdateRequestValues,
} from '@/components/stepConfigs/stepConfigSettingsForms';
import { BetaTestingStepSettings } from '@/types/stepConfig';
import { renderFormFields } from '@/helpers/formHelpers';

interface BetaSoakSettingsProps {
    open: boolean;
    isLoading: boolean;
    currentBetaStyle: BetaTestingStyle;
    prescribedSoakDuration?: number; // when the beta style is timeLimitedSoak, also specify the soak duration, in seconds
    onChangeBetaStyle: (BetaTestingStyle, number?) => void;
    onCancel: () => void;
}

const BetaSoakSettings = (props: BetaSoakSettingsProps) => {
    // TODO: Check if we can remove this useState hook since we're not using the value
    const [_, setSelectedBetaStyle] = React.useState(props.currentBetaStyle);
    const [formIsValid, setFormIsValid] = React.useState(false);
    const [form] = useForm();

    const onOk = () => {
        form.validateFields()
            .then((values) => {
                const stepSettings = transformStepConfigSettingsToUpdateRequestValues(
                    ReleaseStepType.BetaTesting,
                    values,
                    null,
                    null,
                    null,
                );
                props.onChangeBetaStyle(stepSettings.betaTestingStyle, stepSettings.betaSoakDurationSeconds);
            })
            .catch(() => setFormIsValid(false));
    };

    const onValuesChange = () => {
        const betaStyle = form.getFieldValue('betaTestingStyle');

        setSelectedBetaStyle(betaStyle);
    };

    const onFieldsChange = () => {
        const errors = flatMap(form.getFieldsError().map((field) => field.errors));

        setFormIsValid(errors.length === 0);
    };

    const initialSoakDuration =
        props.prescribedSoakDuration ? dayjs.duration(props.prescribedSoakDuration, 'seconds').asHours() : 24;

    const initialValues: BetaTestingStepSettings = {
        betaTestingStyle: props.currentBetaStyle,
        prescribedBetaSoakDurationSeconds: initialSoakDuration,
        googleTestingTrackName: null,
        upstreamCIStepConfigId: null,
        upstreamCIStepConfigOptions: {},
    };

    const stepConfigSettingsFields = getBetaTestingStepFields({ isEditable: true });

    return (
        <Modal
            title="Choose your beta testing style"
            open={props.open}
            confirmLoading={props.isLoading}
            onOk={onOk}
            okButtonProps={{ disabled: !formIsValid, loading: props.isLoading }}
            onCancel={props.onCancel}
            afterClose={() => {
                form.resetFields();
                setFormIsValid(false);
            }}
        >
            <div>
                <Form
                    form={form}
                    name="beta"
                    initialValues={initialValues}
                    onValuesChange={onValuesChange}
                    onFieldsChange={onFieldsChange}
                    validateMessages={{
                        required: '${label} is required.',
                    }}
                >
                    {renderFormFields(stepConfigSettingsFields)}
                </Form>
            </div>
        </Modal>
    );
};

export default BetaSoakSettings;
